export const CONTACT_TYPE = {
  agent: '9fc9201a-b35d-4803-959e-dad63f6936e1',
  external: 'external-contact-type-id-should-go-here',
  supervisor: 'supervisor-type-id-should-go-here',
  channel: '9000fe3f-4640-4906-a695-d756e55cace5',
  businessProcess: 'da0eeae6-4d4f-434a-b45d-4113563f5882',
  enterprise: 'enterprise-type-id-should-go-here',
  crm: 'crm-contact-type-id-should-go-here',
  unknown: '00000000-0000-0000-0000-000000000000'
};

export const STR_CONTACT_TYPE = {
  CRM: 'CRM'
};

export const NOTE_TYPE = {
  note: 'Contact Note',
  remark: 'Interaction Remark'
};
